import httpClient from '@/services/httpClient'
import { CHATLAYER_STATUS_API } from './constants'
import { CheckChatlayerAvailabilityResponse } from './types'

export const checkChatlayerAvailability =
  async (): Promise<CheckChatlayerAvailabilityResponse> => {
    const response = await httpClient.get<CheckChatlayerAvailabilityResponse>(
      CHATLAYER_STATUS_API,
    )

    return response?.data
  }
